import React from 'react'
import { GridElement } from '..'
import { Accordion } from '../../components/allComponents'
import { AccordionProps } from '../../components/accordion/AccordionComponent'

export const AccordionComponent: React.FC<GridElement> = props => {

    if (!props.value) return null
    
    const accordionSections = props.value.map((section, index) => ({
        id: index,
        sectionHeader: section.title,
        sectionContent: section.text,
        isOpenByDefault: false
    }))

    const propsNew: AccordionProps = {
        config: {
            openMultipleSections: false
        },
        sections: accordionSections
    }

    return <Accordion {...propsNew} />
}
